import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { InnovationContentRoutingModule } from './innovation-content-routing.module';
import { InnovationcontentListComponent } from './innovationcontent-list/innovationcontent-list.component';
import { InnovationcontentCreateComponent } from './innovationcontent-create/innovationcontent-create.component';

@NgModule({
  declarations: [InnovationcontentListComponent, InnovationcontentCreateComponent],
  imports: [
    CommonModule,
    InnovationContentRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class InnovationContentModule { }
